import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React from 'react';
import clsx from 'clsx';
import Button from "../../Button";






import CarrierLogo from "../common/CarrierLogo";
import TitleWithSelectedIcon from "../common/TitleWithSelectedIcon";
import { createStyles } from "./styles";
import ProductRates from "../common/ProductRates";
import { filterByPlAndAttrField } from "../common/utils";
import ProductTiles from "../common/ProductTiles";








var EeElectionCard = function EeElectionCard(props) {
  var
    productLineAttributes =



    props.productLineAttributes,_props$product = props.product,imProductId = _props$product.imProductId,carrier = _props$product.carrier,productLine = _props$product.productLine,productDisplayName = _props$product.productDisplayName,bcDependentData = _props$product.bcDependentData,selectedIndex = props.selectedIndex,isProductSelected = props.isProductSelected;

  var classes = createStyles();

  var cardContent = function cardContent() {
    var currentBcInfo = bcDependentData[selectedIndex];
    var productAttributes = currentBcInfo.productAttributes,rates = currentBcInfo.rates;

    return /*#__PURE__*/(
      React.createElement("div", { key: "productCard_".concat(imProductId) }, /*#__PURE__*/
      React.createElement("header", { className: classes.header }, /*#__PURE__*/
      React.createElement(TitleWithSelectedIcon, {
        title: productDisplayName,
        showIcon: true,
        isCartItemSelected: isProductSelected })), /*#__PURE__*/




      React.createElement("div", { key: imProductId, className: classes.productContentWrapper }, /*#__PURE__*/
      React.createElement("div", { className: classes.productMainData }, /*#__PURE__*/
      React.createElement(ProductRates, {
        id: imProductId,
        rates: rates,
        styles: clsx(
        classes.ratesList,
        // hide border if there are no dynamic links
        ProductDynamicLinks(productAttributes).length === 0 && classes.ratesAdditionalStyle) }),


      ProductDynamicLinks(productAttributes)), /*#__PURE__*/


      React.createElement(ProductTiles, {
        productLineAttrs: productLineAttributes,
        productAttrs: productAttributes,
        productLine: productLine,
        styles: classes.productTiles }))));




  };
  // Dynamic links in attributes info
  var ProductDynamicLinks = function ProductDynamicLinks(productAttrs) {var _context;
    return _mapInstanceProperty(_context = filterByPlAndAttrField(productLineAttributes, 'link', productLine)).call(_context,
    function (_ref) {var _productAttrs$find, _context2;var displayName = _ref.displayName,id = _ref.id;
      // get attribute value from the list of all product attributes
      var currentAttrLink =
      ((_productAttrs$find = _findInstanceProperty(productAttrs).call(productAttrs, function (_ref2) {var attributeId = _ref2.attributeId;return attributeId === id;})) === null || _productAttrs$find === void 0 ? void 0 : _productAttrs$find.attributeValue) || '';

      return /*#__PURE__*/(
        React.createElement(Button, {
          id: _concatInstanceProperty(_context2 = "".concat(imProductId, "-attr")).call(_context2, id),
          key: id,
          type: "text",
          color: "primary",
          className: classes.actionButton,
          onClick: function onClick() {
            window.open(currentAttrLink, '_blank');
          } },

        displayName));


    });

  };

  return /*#__PURE__*/(
    React.createElement("div", {
      className: clsx(
      classes.cartItemContentWrapper,
      isProductSelected && classes.cartItemContentWrapperChecked),

      key: "planCard_".concat(imProductId) }, /*#__PURE__*/

    React.createElement(CarrierLogo, { carrier: carrier }),
    cardContent()));


};

export default EeElectionCard;
//# sourceMappingURL=index.js.map